import { Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    useEditPolicyMutation,
    useGetIndividualPolicyQuery,
} from '../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../shared/AuthRoles';
import PolicyForm from '../../components/Policies/PolicyForm';
import toast from '../../shared/Toast';
import { Policy } from '../../types/policy';

const EditPolicyPage = () => {
    const loggedInUser = UserRole();

    const navigate = useNavigate();

    const { id } = useParams();
    const { data: policy } = useGetIndividualPolicyQuery([
        loggedInUser?.company,
        id,
    ]);

    const [editPolicy] = useEditPolicyMutation();

    const onSubmit = (request: Policy) => {
        editPolicy([loggedInUser?.company, id, request]).then((data: any) => {
            if (data?.error) {
                toast.error(data.error.data.message);
            } else {
                toast.success(`Policy has been updated`);
                navigate('/policies');
            }
        });
    };

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'policiesPage',
                },
            });
        }
    }, [loggedInUser.role]);

    return (
        <Stack width='100%' height='80%' gap='40px'>
            <Typography variant='h1' gutterBottom>
                EDIT POLICY
            </Typography>
            <PolicyForm onSubmit={onSubmit} policy={policy} />
        </Stack>
    );
};

export default EditPolicyPage;
